import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { sxFeatureCard } from './sxProps';

const GestaoDeCronicosButton: React.FC<{ title: string, handleClick: () => void, icon: IconDefinition }> = ({ title, handleClick, icon }) => {

    const accessibility = useAccessibility();

    return (
        <>
            <Button sx={sxFeatureCard} onClick={handleClick} style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
                <FontAwesomeIcon icon={icon} style={accessibility.contrastColorAccessibility} size="xl" className='feature-card-icon' />
                <span className='gestao-cronicos-button-name' style={accessibility.textStyleAccessibility}>{title}</span>
            </Button>
        </>
    );
}

export default GestaoDeCronicosButton;